<section class="w-full flex flex-wrap justify-center items-center overflow-hidden">
    <div class="w-full flex flex-wrap content-start bg-white dark:bg-gray-900 rounded-lg p-4">
        <div
            class="w-full flex flex-wrap justify-between items-center border-b border-gray-100 dark:border-gray-600 pb-4">
            <!-- info -->
            <img class="w-6" src="https://cloud.behkhaan.ir/assets/icons/beh-logo.svg">


            <div class="w-full flex flex-wrap mt-4">
                <!-- post img -->
                <img class="aspect-2/1 w-full object-cover rounded-lg"
                    [src]="data?.mediaId | image : imageType.post : data?.hasPhoto" [alt]="data?.title">


                <!-- title -->
                <p class="w-full font-bold text-sm text-gray-900 mt-3 line-clamp-1">{{data?.title}}</p>

                <span class="w-[18px] h-1 bg-green-500 mt-1"></span>

                <!-- minutes -->
                <div class="w-full flex justify-between items-center mt-3">
                    <div class="flex items-center">
                        <span class="icon timer-regular text-green-500 font-bold text-xl"></span>
                        <p class="font-medium text-xs text-gray-500 mr-1">{{data?.readingTimeInMinutes}} دقیقه</p>
                    </div>

                    <p class="text-sm font-regular text-gray-500">{{data?.actor?.userName + '@' }}</p>
                </div>
            </div>
        </div>
        <!-- <p class="line-clamp-[11] font-bold text-sm leading-7 text-gray-600 mt-4 text-justify">{{data?.body}}</p> -->
        <div class="relative max-h-[200px] overflow-hidden text-ellipsis">
            <quill-view class="w-full prose prose-sm" [content]="data?.body" format="html" theme="snow"></quill-view>
        </div>


    </div>

    <div class="flex flex-wrap flex-col justify-center items-center mt-4">
        <p class="text-xs text-gray-700 dark:text-gray-200 font-medium">بهخوان | شبکهٔ اجتماعی کتاب</p>

        <div class="relative w-full my-4">
            <div class="border-t border-gray-500 dark:border-gray-400 absolute top-1/2 left-0 right-0"></div>
            <p
                class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-green-10 dark:bg-green-1000 px-2 text-green-500 text-sm font-medium">
                behkhaan.ir</p>
        </div>
    </div>

</section>